import React, { Component } from "react";
import {
    DKLabel,
    DKLine,
    DKInputForm,
    DKInput,
    DKButton,
    showToast,
    TOAST_TYPE,
    showLoader,
    removeLoader,
    INPUT_VIEW_DIRECTION
} from "deskera-ui-library";

import DataGridUtility from "../../utility/DataGridUtility";
import { getUserProfilePic } from "../../managers/common/CommonUtil";
import CompanyDetailManager from "../../managers/CompanyDetailManager";
import CompanyDetailService from "../../services/CompanyDetailService";
import { Countries, IN_STATES } from "../../constants/CountryConstant";
import CustomInput from "../../SharedComponents/CustomInput/CustomInput";
import { PAN_REGEX_PATTERN, TAN_REGEX_PATTERN, TDS_REGEX_PATTERN, ZIPCODE_REGEX } from "../../constants/RegexConstants";
import { INPUT_TYPE, PAN_NUMBER_MASK,TAN_NUMBER_MASK, TDS_CIRCLE_MASK, TENENT_COUNTRY } from "../../constants/Constant";
import defaultCompany from "../../assets/images/Default-Organization.svg";
import MessageInfo from "../common/MessageInfo";
export default class CompanyDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formFields: []
        }
    }
    direction = INPUT_VIEW_DIRECTION.VERTICAL
    defaultValues = [];
    columns = [{
        columnCode: "organizationName",
        autoFocus: true,
        editable: true,
        hidden: false,
        id: "BF1x",
        index: 0,
        name: "Company Name",
        options: null,
        required: true,
        systemField: true,
        type: "text",
        uiVisible: true,
        width: 300
    },
    {
        columnCode: "contactNumber",
        editable: true,
        hidden: false,
        id: "BF2x",
        index: 0,
        name: "Contact Number",
        options: null,
        required: false,
        systemField: true,
        type: "number",
        uiVisible: true,
        width: 300
    }, {
        columnCode: "pan",
        editable: true,
        hidden: false,
        id: "BF3x",
        index: 0,
        name: "PAN",
        options: null,
        required: true,
        systemField: true,
        type: "text",
        uiVisible: true,
        width: 300,
        info:`The PAN number should follow the pattern <br> ${PAN_NUMBER_MASK} where S-Alphabet 0-Number`
    },
    {
        columnCode: "tan",
        editable: true,
        hidden: false,
        id: "BF4x",
        index: 0,
        name: "TAN",
        options: null,
        required: true,
        systemField: true,
        type: "text",
        uiVisible: true,
        width: 300,
        info:`The TAN number should follow the pattern <br> ${TAN_NUMBER_MASK} where S-Alphabet 0-Number`
    },
    {
        columnCode: "tds",
        editable: true,
        hidden: false,
        id: "BF5x",
        index: 0,
        name: "TDS Circle/AO Code",
        options: null,
        required: true,
        systemField: true,
        type: "text",
        uiVisible: true,
        width: 300,
        info:`The TDS Circle/AO Code number should follow the <br>pattern ${TDS_CIRCLE_MASK} where S-Alphabet 0-Number`
    },
    {
        columnCode: "addressLine1",
        editable: true,
        hidden: false,
        id: "BF6x",
        index: 0,
        name: "Address Line1",
        options: null,
        required: true,
        systemField: true,
        type: "text",
        uiVisible: true,
        width: 300
    },
    {
        columnCode: "addressLine2",
        editable: true,
        hidden: false,
        id: "BF7x",
        index: 0,
        name: "Address Line2",
        options: null,
        required: false,
        systemField: true,
        type: "text",
        uiVisible: true,
        width: 300
    },
    {
        columnCode: "zipCode",
        editable: true,
        hidden: false,
        id: "BF8x",
        index: 0,
        name: "Zip Code",
        options: null,
        required: true,
        systemField: true,
        type: "text",
        uiVisible: true,
        width: 300,
        info: 'zipcode format (Example: 411006) '
    },
    {
        columnCode: "city",
        editable: true,
        hidden: false,
        id: "BF9x",
        index: 0,
        name: "City",
        options: null,
        required: true,
        systemField: true,
        type: "text",
        uiVisible: true,
        width: 300
    },
    {
        columnCode: "state",
        editable: true,
        hidden: false,
        id: "BF0y",
        index: 0,
        name: "State",
        options: IN_STATES,
        required: true,
        systemField: true,
        type: INPUT_TYPE.SELECT,
        uiVisible: true,
        width: 300
    },
    {
        columnCode: "country",
        editable: false,
        hidden: false,
        id: "BF1y",
        index: 0,
        name: "Country",
        options: Countries,
        required: true,
        systemField: true,
        type: INPUT_TYPE.SELECT,
        uiVisible: true,
        width: 300
    },
    {
        columnCode: "isWorkLocation",
        editable: true,
        hidden: false,
        id: "BF2y",
        index: 0,
        name: "This is work location",
        options: [{ value: true, label: 'Yes' }, { value: false, label: 'No' }],
        required: false,
        systemField: true,
        type: INPUT_TYPE.SELECT,
        uiVisible: true,
        width: 300
    }
    ];
    componentDidMount() {
        showLoader()
        CompanyDetailService.getCompanyDetail()
            .then((responseData) => {
                removeLoader()
                this.defaultValues = responseData['tenant'];
                if(this.defaultValues.address.state == "") {
                    this.defaultValues.address.state = IN_STATES[0].value // set defult
                }
                if(this.defaultValues.address.country == "") {
                    this.defaultValues.address.country = TENENT_COUNTRY // defualut country
                }
                if(this.defaultValues.compliance) {
                    switch(this.defaultValues.address.country) {
                        case TENENT_COUNTRY:
                            this.defaultValues.compliance['@type']='type.googleapis.com/v1.INTenantCompliance';
                            break;
                        default:
                            this.defaultValues.compliance['@type'] = 'type.googleapis.com/v1.DefaultCompliance'
                    }

                }
                this.buildForm();
            })

    }
    buildForm = () => {
        this.processDataForForm()
        this.putAdditionalFields().then(() => {
            let formFields = DataGridUtility.getFormElementsByKey(
                this.columns,
                this.defaultValues
            );
            this.setState({
                formFields:formFields
            });


            this.props.setData(this.defaultValues, this.isValidFormDetail());
        });
    }
    putAdditionalFields = () => {
        return Promise.resolve();
    };
    processDataForForm = () => {

        this.columns.forEach(column => {
            column['key'] = column.columnCode;
        });
        Object.assign(this.defaultValues, this.defaultValues.address)
        Object.assign(this.defaultValues, this.defaultValues.compliance);
        // this.defaultValues['isWorkLocation'] = this.defaultValues['isWorkLocation'] ? ['yes'] : ['no']
        // this.defaultValues['country'] = this.defaultValues['country'] ? [this.defaultValues['country']] : [];
        // this.defaultValues['state'] = this.defaultValues['state'] ? [this.defaultValues['state']] : [];
        // CompanyDetailManager.getDataToUpdateForCompany(this.defaultValues, this.columns);

    }

    getBannerMessageForCompany() {
        let messageGroup = [{
            message: "We have added the company details you entered during onboarding. You can makes changes here.",
            isAction: false
        }];
        return messageGroup;
    }

    render() {
        return (
          <div className="column parent-width">
            <MessageInfo
              bannerClass={"mb-l"}
              message={this.getBannerMessageForCompany()}
              isClosable={true}
            />
            <div className=" parent-width bg-white border-radius-s card-shadow">
              {false && this.getCompanyLogo()}
              <DKLabel
                text="Company Details"
                className="fw-m fs-l mb-r pt-l p-h-l"
              />
              <DKLine className="bg-line-2" />
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                }}
                className=" parent-width mb-s mt-l"
              >
                {this.state.formFields && this.getFormFields()}
                {}
              </div>
            </div>
          </div>
        );
    }
    scrollToBottom = () => {
        setTimeout(() => {
            const holder = document.getElementById("dk-form-popup-window");
            if (holder) {
                holder.scrollTop = holder.offsetHeight;
            }
        }, 10);
    };

    showAlert() {
        this.state.formFields.forEach((ele,index)=>{
            this.showInvalidFields(ele,index);
        })
    }
    getFormFields() {
        let fields = this.state.formFields.map((obj, index) => {
            return (

                <div className="" style={{
                    flex: "0 0 50%",
                    maxWidth: "50%"
                }}
                    key={obj.id}>
                    <div className="m-h-l">
                    <CustomInput
                        autoFocus={index === 0 && this.props.autoFocus === true}
                        className={"p-v-s p-h-l"}
                        icon={obj.icon}
                        labelName={obj.name}
                        placeholder={obj.name}
                        defaultValue={obj.value}
                        options={obj.options}
                        type={obj.type}
                        hasError={obj.hasError}
                        errorMsg={obj.errorMsg}
                        readOnly={!obj.editable}
                        labelClassName=" text-align-left "
                        canValidate={this.state.canValidate}
                        onChange={(value) => {
                            this.onChange(value, index)
                        }}
                        direction={this.direction}
                        isRequired={obj.required}
                        isDisabled={!obj.editable}
                        dateFormat={this.props.dateFormat}
                        readOnly={this.props.readOnly}
                        info={obj.info ? obj.info: ""}
                        onClick={() => {

                            if (index === this.state.formFields.length - 1) {
                                this.scrollToBottom();
                            }
                        }}
                    />
                    </div>
                </div>
            )
        })
        return fields;
    }
    onChange(value, index) {
        let data = this.state.formFields[index];
        data["value"] = value.target ? value.target.value : value['value'];
        const dataValue = data["value"].toString();
        switch (data['columnCode']) {
            case "pan":
                const regexPAN = new RegExp(PAN_REGEX_PATTERN);
                this.state.formFields[index].errorMsg = "Please enter Valid PAN Details";
                this.state.formFields[index].hasError = !regexPAN.test(dataValue);
                break;
            case "tan":
                const regexTAN = new RegExp(TAN_REGEX_PATTERN);
                this.state.formFields[index].hasError = !regexTAN.test(dataValue);
                this.state.formFields[index].errorMsg = "Please enter Valid TAN Details";
                break;
            case "tds":
                const regexTDS = new RegExp(TDS_REGEX_PATTERN);
                this.state.formFields[index].hasError = !regexTDS.test(dataValue);
                this.state.formFields[index].errorMsg = "Please enter Valid TDS Details";
                break;
            case "zipCode":
                const regexZIP = new RegExp(ZIPCODE_REGEX.IND);
                this.state.formFields[index].hasError = !regexZIP.test(dataValue);
                this.state.formFields[index].errorMsg = "Please enter Valid zip code Details";
                break;
            default:
                if (this.state.formFields[index].required) {
                    this.state.formFields[index].hasError = (dataValue.trim() == "") ? true : false;
                    this.state.formFields[index].errorMsg = "Field cannot be empty";
                }
        }
        this.setState({
            formFields: this.state.formFields
        });
        setTimeout(() => {
            let { finalData, isValid } = CompanyDetailManager.processDataForSubmit(data, this.defaultValues);
            this.defaultValues = finalData;
            this.props.setData(finalData, this.isValidFormDetail());
        }, 100)
        if (this.props.onChange) {
            this.props.onChange(this.state.formFields, data);
        }
    }
    isValidFormDetail() {
        let isValid = true;
        this.state.formFields.forEach(field => {
            if((field.hasError || field.required)&& typeof field.value == "number" && field.value == 0) {
                // do later
            } else
            if (field.hasError || (field.required && ((field.value&&field.value.toString()) =='') || field.value == undefined )) {
                isValid = false;
            }
        })
        return isValid;
    }
    getCompanyLogo(obj) {
        return (
            <>
                <div className="row  p-l">
                    <div className="column">
                        {this.defaultValues['organizationName']&&<img className="mr-s border-radius-xxl" style={{ height: 65, width: 65 }} src={getUserProfilePic({
                            name: this.defaultValues['organizationName'] ? this.defaultValues['organizationName'] : ' ',
                            backgroundColor: '#001F42',
                            textColor: '#FFF',
                            font: 'bold 24px sans-serif',
                            height: 72,
                            width: 72,
                        })}
                        // onError={(e)=>{e.target.onerror = null; e.target.src="https://i.picsum.photos/id/739/200/300.jpg?hmac=xApsFbHx511SUVG612QiltrATotVTYu3Q4wfvGyYC1g"}}
                        />}
                        {!this.defaultValues['organizationName']&&
                            <img className="mr-s border-radius-xxl" style={{ height: 65, width: 65 }} src={defaultCompany}/>
                        }
                    </div>
                    <div className="column">
                        <DKLabel text="Company Details" className="fw-m fs-l mt-s text-gray" />
                        <p className="mb-s text-gray fw-m" style={{ marginTop: '0px' }}></p>

                    </div>
                </div>
            </>
        )
    }
    showInvalidFields(value,index){
        let data = this.state.formFields[index];
        if(typeof data.value == "number" && data.value == 0) {
            // do later
        } else {
            data["value"] =  (value['value'] ? value['value']:"");
        }

        const dataValue = data["value"].toString();
        switch (data['columnCode']) {
            case "pan":
                const regexPAN = new RegExp(PAN_REGEX_PATTERN);
                this.state.formFields[index].errorMsg = "Please enter Valid PAN Details";
                this.state.formFields[index].hasError = !regexPAN.test(dataValue);
                break;
            case "tan":
                const regexTAN = new RegExp(TAN_REGEX_PATTERN);
                this.state.formFields[index].hasError = !regexTAN.test(dataValue);
                this.state.formFields[index].errorMsg = "Please enter Valid TAN Details";
                break;
            case "tds":
                const regexTDS = new RegExp(TDS_REGEX_PATTERN);
                this.state.formFields[index].hasError = !regexTDS.test(dataValue);
                this.state.formFields[index].errorMsg = "Please enter Valid TDS Details";
                break;
            case "zipCode":
                const regexZIP = new RegExp(ZIPCODE_REGEX.IND);
                this.state.formFields[index].hasError = !regexZIP.test(dataValue);
                this.state.formFields[index].errorMsg = "Please enter Valid zip code Details";
                break;
            default:
                if (this.state.formFields[index].required) {
                    let field = this.state.formFields[index]
                    if((field.hasError || field.required)&& typeof field.value == "number" && field.value == 0) {
                        // do later
                    } else
                    if (field.hasError || (field.required && (field.value&&field.value.toString()) =='')) {
                        this.state.formFields[index].hasError = (dataValue.trim() == "") ? true : false;
                        this.state.formFields[index].errorMsg = "Field cannot be empty";
                    }
                }
        }
        this.setState({
            formFields: this.state.formFields
        });

    }
}